<template>
  <div class="component-small-class">
    <h1 class="h1 color-gray-1">
      富国穷国背后的经济学原理 <br class="m-only" />
      <span class="color-gray-4">Development Economics</span>
    </h1>
    <VideoPlayer :videos="videos" :isPaid="isPaid"></VideoPlayer>
    <p class="text1 color-gray-2 mt-24">
      为什么世界上有些国家富裕，而有些国家贫穷？<br />
      为什么2019年诺贝尔经济学奖得主的研究，对改善全球贫困影响重大？<br />
      发展经济学（Development Economics）主要研究的是经济发展欠发达的农业国家或发展中国家如何实现工业化、摆脱贫困、走向富裕的过程。
    </p>
    <p class="text1 color-gray-2 mt-10">
      经济学是哈佛大学最富盛名的热门学科之一，而学好发展经济学能够帮助你更好地理解中国和世界经济发展背后的学术原理、以及我们身处的世界经济。在这堂课上，哈佛的Philip老师将带你走进发展经济学的世界。希望学完这堂课，当你阅读中英文财经新闻的时候，看到一些名词和概念就能给身边的小伙伴讲一讲啦！
    </p>
  </div>
</template>
<script>
import Mixin from '../mixin.vue';
/**
 * @module Positive
 * @desc 幸福学课程内页
 */
export default {
  name: 'Positive',
  mixins: [Mixin],
  data() {
    return {
      videos: [
        { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/Financial/E1.mp4', index: 1 },
        { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/Financial/E2.mp4', index: 2 },
        { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/Financial/E3.mp4', index: 3 },
        { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/Financial/E4.mp4', index: 4 },
        { url: 'https://hsylc.oss-cn-hangzhou.aliyuncs.com/2022/student_file/Financial/E5.mp4', index: 5 }
      ]
    };
  }
};
</script>
